import { Button } from 'antd'
import React from 'react'
import { MdArrowBackIos } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

const BackButton = ({ path, text }) => {
    const navigate = useNavigate();
    let linkTo = path || -1;
    return (
        <Button
            color="default"
            variant="link"
            onClick={() => navigate(linkTo)}
            icon={<MdArrowBackIos />}
        >
            {text || 'Back'}
        </Button>
    )
}

export default BackButton